import { useParams } from "react-router-dom"
import { UniversalReport } from "../universalReport/universalReport.component"

export const ViewReport = () => {
  const { reportId } = useParams()
  return <UniversalReport reportId={reportId} />
}